// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3QA_u","containerItemsCenter":"Skeleton_containerItemsCenter__3Xwr-"};